import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ActionButtonWrapper = styled.div`
  grid-area: actions;

  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  ${QUERIES.largeTabletAndUp} {
    flex-direction: row;
  }

  button,
  a {
    position: relative;

    .popularity {
      position: absolute;
      right: 16px;
      width: 100%;
      text-align: right;
      color: ${themeStyle.varInkBase};
      opacity: 0.8;
    }
  }
`;

export const RightButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  ${QUERIES.largeTabletAndUp} {
    width: unset;
  }
`;
